<template>
    <div class="gift_receive_root">
        <div class="gift_receive_description">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <path style="fill:#ADEBFF;" d="M304.489,413.234c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.19,54.879
                    l6.323,18.966c26.517-26.517,61.11-60.797,61.457-61.14C307.939,422.406,307.965,416.743,304.489,413.234z"/>
                <path style="fill:#51E9D3;" d="M304.489,372.99c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.191,54.88
                    l6.324,18.965c26.517-26.517,61.11-60.797,61.457-61.14C307.939,382.161,307.965,376.499,304.489,372.99z"/>
                <path style="fill:#E0F4B4;" d="M322.135,85.486V99.65l-85.486,119.023L203.112,93.158L236.649,0
                    C283.869,0,322.135,38.277,322.135,85.486z"/>
                <path style="fill:#51E9D3;" d="M189.865,46.784v327.3c0,25.846,15.483,35.069,46.784,66.37V0
                    C210.814,0,189.865,20.95,189.865,46.784z"/>
                <polygon style="fill:#51A978;" points="322.135,99.65 322.135,212.838 236.649,331.861 236.649,185.136 "/>
                <path style="fill:#3AC099;" d="M322.135,212.838v66.113c0,47.209-28.283,64.056-85.486,121.259V298.324L322.135,212.838z"/>
                <path style="fill:#80086E;" d="M236.65,512c-4.939,0-8.943-4.004-8.943-8.943V33.537c0-4.939,4.004-8.943,8.943-8.943
                    c4.939,0,8.943,4.004,8.943,8.943v469.52C245.593,507.996,241.59,512,236.65,512z"/>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>

            <h2 v-if="getGiftSucceeded">{{this.receivingGift ? this.receivingGift.senderName : ''}}からお祝いが届いています！</h2>
            <h2 v-else-if="inProgress">お祝イーサーを受信中です</h2>
        </div>

        <at-card v-if="getGiftSucceeded"
                 class="receive_card eth_gift_card"
        >
            <h4 slot="title">
                {{this.receivingGift ? this.receivingGift.receiverName : ''}}へ
            </h4>
            <div>
                <p class="message_and_price">
                    {{this.receivingGift ? this.receivingGift.message : ''}}<br>
                    {{`${this.receivingGift ? this.receivingGift.etherPrice : ''} ETH`}}
                </p>
                <at-button
                        type="primary"
                        v-on:click="receiveGift"
                        :disabled="inProgress"
                >
                    受け取る
                </at-button>
            </div>
        </at-card>
        <h2 v-else>お祝イーサーの取得に失敗しました。URLが間違っていないかご確認ください。</h2>

    </div>
</template>

<script>
  import store from '../store'
  import { mapGetters } from 'vuex'

  export default {
    name: 'GiftReceive',
    components: {
    },
    data () {
      return {
        receiverMailAddress: ''
      }
    },
    computed: {
      ...mapGetters([
        'getGiftSucceeded',
        'receivingGift',
        'receiveGiftSucceeded',
        'inProgress',
        'notificationMessage'
      ])
    },
    watch: {
      inProgress: function (newValue, oldValue) {
        const isProgressEnd = oldValue && !newValue
        if (isProgressEnd) {
          this.$Loading.finish()
        }
      },
      receiveGiftSucceeded: function (newValue, oldValue) {
        const isReceivingSucceeded = newValue
        if (isReceivingSucceeded) {
          this.$Message.success('受け取りました！')
        } else {
          this.$Message.error(this.notificationMessage)
        }
      }
    },
    mounted: function () {
      store.dispatch('getGift', { uuid: this.$route.query.giftUuid || '' })
    },
    methods: {
      receiveGift () {
        this.$Loading.start()
        store.dispatch('receiveGift', { gift: this.receivingGift })
      }
    }
  }
</script>

<style lang="scss">
    h1, h2 {
        font-weight: normal;
        margin: 16px 0;
    }

    p {
        line-height: 32px;
        word-wrap: break-word;
    }

    .gift_receive_root {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .gift_receive_description {
        margin-bottom: 32px;

        svg {
            width: 84px;
        }
    }

    .message_and_price {
        margin-bottom: 20px;
    }

    @media screen and (min-width: 480px) {
        .eth_gift_card {
            width: 60%;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/GiftReceive.vue